// app/javascript/controllers/collapse_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    console.debug("collapse#connect", this.element);
    this.show = this.hasContentTarget && this.contentTarget.classList.contains("show");
    this.updateIcon();
    // assicurati aria-expanded coerente all'avvio
    this._updateTriggerAria();
  }

  toggle(event) {
    if (event) event.preventDefault();
    if (!this.hasContentTarget) {
      console.warn("collapse controller: missing content target");
      return;
    }

    this.show = !this.show;
    this.contentTarget.classList.toggle("show", this.show);

    // aggiorna aria-expanded sul trigger (il bottone)
    const trigger = event?.currentTarget || this.element.querySelector('[data-action*="collapse#toggle"]');
    if (trigger) trigger.setAttribute("aria-expanded", String(this.show));

    this.updateIcon();
    console.debug("collapse#toggle ->", this.show);
  }

  updateIcon() {
    if (!this.hasIconTarget) return;
    this.iconTarget.textContent = this.show ? "−" : "+";
  }

  _updateTriggerAria() {
    const trigger = this.element.querySelector('[data-action*="collapse#toggle"]');
    if (trigger) trigger.setAttribute("aria-expanded", String(!!this.show));
  }
}
